import { useQuery } from '@tanstack/react-query'
import type { V2GetStartupFeatureFlagsResponse } from '@workspace/api-backend'
import { v2GetStartupFeatureFlagsOptions } from '@workspace/api-backend/react-query'

/**
 * Resolve feature flag values for the given startup. Backend returns one
 * boolean per known flag key. Read-only — admins toggle flags via the admin
 * page (see `features/feature-flags/hooks/use-admin-feature-flags.ts`).
 */
export function useStartupFeatureFlagsQuery(startupId: string, options?: { enabled?: boolean }) {
  return useQuery({
    ...v2GetStartupFeatureFlagsOptions({ path: { id: startupId } }),
    select: (response: V2GetStartupFeatureFlagsResponse) => response.data,
    ...options,
  })
}
